import { createFileRoute } from '@tanstack/react-router'
import { PayrollBreakdownPage } from '@/features/payroll/ui/PayrollBreakdownPage'
import { PayrollAccessDenied } from '@/features/payroll/ui/PayrollAccessDenied'
import { PermissionGuard } from '@/shared/components/PermissionGuard'
import { PERMISSIONS } from '@/shared/config/permissions'

export const Route = createFileRoute(
  '/payroll/runs/$runId/employees/$userId/',
)({
  component: BreakdownRoute,
  staticData: { authorize: true },
})

function BreakdownRoute() {
  const { runId, userId } = Route.useParams()
  return (
    <PermissionGuard
      permission={PERMISSIONS.PayrollView}
      fallback={<PayrollAccessDenied />}
    >
      <PayrollBreakdownPage runId={Number(runId)} userId={Number(userId)} />
    </PermissionGuard>
  )
}
